import React from 'react'

type Props = {
   title?: string
   className?: string
   variant?: 'embedded' | 'standalone'
}

const ExampleSentencesHeader = ({
   title = 'Used in real sentences',
   className,
   variant = 'embedded',
}: Props) => {
   const variantClass =
      variant === 'standalone'
         ? 'm-[0_0_20px_2px] text-[26px] font-bold text-bodyBlack'
         : 'mb-[6px] text-[13px] font-bold tracking-[1.2px] uppercase text-textMuted'

   const iconSizeClass = variant === 'standalone' ? 'text-[20px]' : 'text-[16px]'

   return (
      <div
         className={`flex items-center justify-between ${variantClass} ${className ?? ''}`.trim()}
      >
         <span className="leading-[1.2]">{title}</span>
         <div
            className="group/help relative inline-flex items-center cursor-pointer outline-none"
            tabIndex={0}
            aria-label="About sentence translations"
         >
            <span
               className={`material-icons text-textMuted transition-colors duration-150 group-hover/help:text-translit group-focus-visible/help:text-translit ${iconSizeClass}`}
            >
               help_outline
            </span>
            <div
               className="absolute bottom-[calc(100%+8px)] right-0 z-30 w-[260px] p-[10px_13px] rounded-[8px] bg-bodyBlack text-white text-[12px] font-normal leading-[1.45] normal-case tracking-normal shadow-[0_4px_14px_rgba(0,0,0,0.18)] opacity-0 pointer-events-none transition-all duration-150 translate-y-[4px] group-hover/help:opacity-100 group-hover/help:pointer-events-auto group-hover/help:translate-y-0 group-focus-within/help:opacity-100 group-focus-within/help:pointer-events-auto group-focus-within/help:translate-y-0 after:content-[''] after:absolute after:top-full after:right-[4px] after:border-5 after:border-solid after:border-t-bodyBlack after:border-x-transparent after:border-b-transparent"
               role="tooltip"
            >
               Sentence translations focus on natural phrasing in context, so they may differ
               slightly from literal dictionary definitions.
            </div>
         </div>
      </div>
   )
}

export default ExampleSentencesHeader
